module.exports = __webpack_public_path__ + "img/img4.7458b53d.png";